var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9998 17L12.9998 3H10.9998L10.9998 13H9.00006V11H7.00006V13H8.99994V15H10.9998V17H12.9998ZM20.9998 18.9999V15H18.9998V18.9999L4.99982 18.9999L4.99982 15H2.99982V18.9999V20.9999V21L4.99982 21V20.9999L18.9998 20.9999V21L20.9998 21V20.9999V18.9999ZM13 12.9999V14.9999H15V12.9999H17V10.9999H15V12.9999H13Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadM);
export default __webpack_public_path__ + "static/media/download-m.e3d3da59114d31011281669a43ba2a29.svg";
export { ForwardRef as ReactComponent };